<template>
  <div class="user-query-page">
    <h2 class="title">📊 用户使用行为查询</h2>

    <div class="filters">
      <div class="filter-item">
        <label>📅 起始日期：</label>
        <input type="date" v-model="startDate" />
      </div>
      <div class="filter-item">
        <label>📅 截止日期：</label>
        <input type="date" v-model="endDate" />
      </div>
      <div class="filter-item keyword">
        <label>🔍 搜索：</label>
        <input type="text" v-model="keyword" placeholder="请输入姓名 / 邮箱 / 手机 / 单位名称 / 单位类型" />
      </div>
      <button class="btn-search" @click="fetchData">查询</button>
    </div>

    <table class="result-table">
      <thead>
        <tr>
          <th>用户ID</th>
          <th>姓名</th>
          <th>邮箱</th>
          <th>手机号</th>
          <th>单位类型</th>
          <th>单位名称</th>
          <th>使用总时长</th>
          <th>日均使用时长</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in results" :key="user.user_id">
          <td>{{ user.user_id }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.phone }}</td>
          <td>{{ user.profession || '-' }}</td>
          <td>{{ user.institution_name || '-' }}</td>
          <td>{{ formatDuration(user.total_duration) }}</td>
          <td>{{ formatDuration(calculateDailyAverage(user.total_duration)) }}</td>
        </tr>
        <tr v-if="results.length === 0">
          <td colspan="8">暂无数据</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button :disabled="page === 1" @click="page--">« 上一页</button>
      <span>第 {{ page }} / {{ totalPages }} 页</span>
      <button :disabled="page === totalPages" @click="page++">下一页 »</button>
    </div>

    <!-- <div class="summary">
      🧮 当前筛选总时长：
      <strong>{{ formatDuration(totalDuration) }}</strong>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UserQuery',
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      startDate: today,
      endDate: today,
      keyword: '',
      results: [],
      totalDuration: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      totalCount: 0
    };
  },
  methods: {
    calculateDailyAverage(totalDuration) {
      if (!totalDuration) return 0;
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      const days = Math.max(1, Math.ceil((end - start) / (1000 * 60 * 60 * 24)));
      return Math.floor(totalDuration / days);
    },
    async fetchData() {
      try {
        const res = await axios.get('/api/admin/users/query', {
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
            keyword: this.keyword,
            page: this.page,
            limit: this.limit,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
          },
        });

        this.results = res.data.data;
        this.totalDuration = res.data.total_duration;
        this.totalCount = res.data.total_count || 0;
        this.totalPages = Math.ceil(this.totalCount / this.limit) || 1;
      } catch (err) {
        alert('查询失败：' + (err.response?.data?.message || err.message));
      }
    },
    formatDuration(seconds) {
      if (!seconds || seconds <= 0) return '0分钟';
      const d = Math.floor(seconds / 86400);
      const h = Math.floor((seconds % 86400) / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      return `${d ? d + '天 ' : ''}${h ? h + '小时 ' : ''}${m}分钟`;
    },
  },
  watch: {
    page() {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.user-query-page {
  padding: 20px;
  background: #f4f7fc;
  font-family: 'Arial', sans-serif;
  animation: fadeIn 0.6s ease;
}

.title {
  font-size: 22px;
  margin-bottom: 20px;
  font-weight: bold;
  color: #0052cc;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  align-items: center;
}

.filter-item label {
  font-weight: bold;
  margin-right: 6px;
}

input[type='date'],
input[type='text'] {
  padding: 6px 10px;
  border: 1px solid #c1c7d0;
  border-radius: 5px;
  outline: none;
}

.keyword {
  flex: 1;
  min-width: 250px;
}

.btn-search {
  padding: 8px 18px;
  background: #0052cc;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.btn-search:hover {
  background: #2684ff;
}

.result-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.result-table th,
.result-table td {
  padding: 12px;
  border: 1px solid #e3e3e3;
  text-align: center;
  font-size: 14px;
  color: #333333;
}

.result-table th {
  background: #ebf1ff;
  color: #333;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 10px;
}

.pagination button {
  padding: 6px 14px;
  background: #0052cc;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.pagination button:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.pagination span {
  font-weight: bold;
  color: #333;
  padding: 4px 10px;
}

.summary {
  margin-top: 20px;
  text-align: right;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
